export const isKeyword = (propType: string) => propType === 'Keyword'
